// 表单控件 // 通过传入参数的type判断当前需要哪一个表单控件

<template>
  <!-- controlItem 是 formList.formData的每一个 item 对象 -->
  <el-form-item
    :prop="controlItem.prop"
    :label="controlItem.label + ':'"
    :rules="controlItem.props.rules"
    v-if="!controlItem.props.isHiden"
  >
    <!-- 可动态增减表单控件 -->
    <!-- 输入框控件 -->
    <el-input
      v-if="controlItem.type === 'Input' && controlItem.isDynamic"
      :placeholder="'请输入' + controlItem.label"
      v-model="dynamicItem[controlItem.prop]"
      :style="controlItem.props.style"
    ></el-input>
    <!-- 输入框包含change事件 -->
    <el-input
      v-if="controlItem.type === 'InputChange' && controlItem.isDynamic"
      v-model="dynamicItem[controlItem.prop]"
      :placeholder="'请选择' + controlItem.label"
      :style="controlItem.props.style"
      @input="InputChange"
    >
    </el-input>
    <!-- 模糊匹配输入框 -->
    <!-- <el-autocomplete -->
    <!-- 匹配输入框 -->
    <el-autocomplete
      v-if="controlItem.type === 'QuerySearch' && controlItem.isDynamic"
      class="inline-input"
      v-model="form[controlItem.prop]"
      :fetch-suggestions="querySearch"
      :placeholder="'请输入'"
      :trigger-on-focus="true"
      :style="controlItem.props.style"
      @select="autocompleteSelect"
    ></el-autocomplete>
    <!-- 单选控件 -->
    <el-radio-group
      v-else-if="controlItem.type === 'Radio' && controlItem.isDynamic"
      v-model="dynamicItem[controlItem.prop]"
      :style="controlItem.props.style"
    >
      <el-radio
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.prop"
        >{{ item.label }}</el-radio
      >
    </el-radio-group>
    <!-- 多选控件 -->
    <el-checkbox-group
      v-else-if="controlItem.type === 'Checkbox' && controlItem.isDynamic"
      v-model="dynamicItem[controlItem.prop]"
      :style="controlItem.props.style"
    >
      <el-checkbox
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
      ></el-checkbox>
    </el-checkbox-group>
    <!-- 下拉列表 -->
    <el-select
      v-else-if="controlItem.type === 'Select' && controlItem.isDynamic"
      :filterable="controlItem.props.filterable"
      v-model="dynamicItem[controlItem.prop]"
      :placeholder="'请选择' + controlItem.label"
      :style="controlItem.props.style"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <!-- 无限下拉 -->
    <el-select
      v-else-if="controlItem.type === 'SelectInfinite' && controlItem.isDynamic"
      v-model="dynamicItem[controlItem.prop]"
      filterable
      remote
      :remote-method="remoteMethod"
      :placeholder="'请选择' + controlItem.label"
      :style="controlItem.props.style"
      v-el-select-loadmore="loadmore"
      :loading="controlItem.props.loading"
      @blur="handleBlur"
      @change="handleChange"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <!-- 级联选择器 -->
    <el-cascader
      v-else-if="controlItem.type === 'Cascader' && controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :options="controlItem.value"
      :props="controlItem.props"
      @change="SelectChange"
      :style="controlItem.props.style"
      :collapse-tags="controlItem.props.collapseTags"
      :clearable="controlItem.props.clearable"
    ></el-cascader>
    <!-- 计数器 -->
    <el-input-number
      v-else-if="controlItem.type === 'InputNumber' && controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      controls-position="right"
      :min="0"
    ></el-input-number>

    <!-- 固定表单控件 -->
    <!-- 输入框控件 -->
    <el-input
      v-if="controlItem.type === 'Input' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :placeholder="'请输入' + controlItem.label"
      :style="controlItem.props.style"
      :maxlength="controlItem.props.maxlength"
      :v-direction="controlItem.props.direction"
      :readonly="controlItem.props.readonly"
      :disabled="controlItem.props.disabled"
    ></el-input>
    <el-input
      v-if="controlItem.type === 'Inputs' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :placeholder="controlItem.props.placeholder"
      :style="controlItem.props.style"
      :maxlength="controlItem.props.maxlength"
      :v-direction="controlItem.props.direction"
      :readonly="controlItem.props.readonly"
      :disabled="controlItem.props.disabled"
    ></el-input>
    <!-- 密码框 -->
    <div>
      <el-input
        v-if="controlItem.type === 'PWD' && !controlItem.isDynamic"
        v-model="form[controlItem.prop]"
        ref="password"
        :type="passwordType"
        :placeholder="'请' + controlItem.label"
        name="password"
        auto-complete="on"
        :style="controlItem.props.style"
      />
      <span
        v-if="controlItem.type === 'PWD' && !controlItem.isDynamic"
        class="show-pwd"
        @click="showPwd"
      >
        <svg-icon
          :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
        />
      </span>
    </div>
    <!-- 输入框包含change事件 -->
    <el-input
      v-if="controlItem.type === 'InputChange' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :placeholder="'请输入' + controlItem.label"
      :style="controlItem.props.style"
      :v-direction="controlItem.props.direction"
      @change="InputChange"
    ></el-input>
    <!-- 文本域输入框 -->
    <el-input
      v-if="controlItem.type === 'Textarea' && !controlItem.isDynamic"
      type="textarea"
      :placeholder="controlItem.props.placeholder"
      v-model="form[controlItem.prop]"
      :maxlength="controlItem.props.maxlength"
      :show-word-limit="controlItem.props.showLimit"
      :style="controlItem.props.style"
      :v-direction="controlItem.props.direction"
      :autosize="controlItem.props.autosize"
      v-bind="controlItem.props.$attrs"
    >
    </el-input>
    <!-- 模糊匹配输入框 -->
    <!-- <el-autocomplete -->
    <!-- 匹配输入框 -->
    <el-autocomplete
      v-if="controlItem.type === 'QuerySearch' && !controlItem.isDynamic"
      class="inline-input"
      v-model="form[controlItem.prop]"
      :fetch-suggestions="querySearch"
      :placeholder="'请输入' + controlItem.label"
      :trigger-on-focus="true"
      @select="handleSelect"
      @focus="handleFocus"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
    >
    </el-autocomplete>
    <!-- 单选控件 -->
    <el-radio-group
      v-else-if="controlItem.type === 'Radio' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      style="width: 220px"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
      @change="changeRadio"
    >
      <el-radio
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.prop"
        >{{ item.label }}</el-radio
      >
    </el-radio-group>
    <!-- 多选控件 -->
    <el-checkbox-group
      v-else-if="controlItem.type === 'Checkbox' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
    >
      <el-checkbox
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
      ></el-checkbox>
    </el-checkbox-group>
    <!-- 下拉列表 -->
    <!-- :filterable="controlItem.props.filterable" -->
    <!-- change事件 -->
    <el-select
      v-else-if="
        controlItem.type === 'SelectWithChange' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      :filterable="controlItem.props.filterable"
      :placeholder="'请选择' + controlItem.label"
      :style="controlItem.props.style"
      :v-direction="controlItem.props.direction"
      @change="SelectChange"
      :id="controlItem.prop"
      :clearable="controlItem.props.clearable"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <el-select
      v-else-if="
        controlItem.type === 'Selectcheckbox' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      multiple
      collapse-tags
      :filterable="controlItem.props.filterable"
      :style="controlItem.props.style"
      :placeholder="'请选择' + controlItem.label"
      :v-direction="controlItem.props.direction"
      @change="SelectChange"
      :id="controlItem.prop"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      >
      </el-option>
    </el-select>
    <!-- 多选（可隐藏选项） -->
    <el-select
      v-else-if="
        controlItem.type === 'SelectcheckboxHidden' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      multiple
      collapse-tags
      :filterable="controlItem.props.filterable"
      :style="controlItem.props.style"
      :placeholder="'请选择' + controlItem.label"
      :v-direction="controlItem.props.direction"
      @change="SelectChange"
      :id="controlItem.prop"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
        :class="item.isHidden ? 'hiddenOption' : ''"
      >
      </el-option>
    </el-select>
    <el-select
      v-else-if="
        controlItem.type === 'Selectcheckboxs' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      multiple
      collapse-tags
      :filterable="controlItem.props.filterable"
      :style="controlItem.props.style"
      :placeholder="'请选择' + controlItem.label"
      :v-direction="controlItem.props.direction"
      @change="SelectChange"
      :id="controlItem.prop"
    >
      <el-checkbox
        class="checkbox"
        v-model="controlItem.props.checked"
        @change="selectAll"
        >全选</el-checkbox
      >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      >
      </el-option>
    </el-select>
    <!-- 无事件 -->
    <el-select
      v-else-if="controlItem.type === 'Select' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :filterable="true"
      :placeholder="'请选择' + controlItem.label"
      :v-direction="controlItem.props.direction"
      :id="controlItem.prop"
      :disabled="controlItem.props.disabled"
      :style="controlItem.props.style"
      @change="selectChangehandel"
      :clearable="controlItem.props.clearable"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <!-- 下拉框无限滚动 -->
    <el-select
      v-else-if="
        controlItem.type === 'SelectInfinite' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      filterable
      remote
      :remote-method="remoteMethod"
      :placeholder="'请选择' + controlItem.label"
      :style="controlItem.props.style"
      v-el-select-loadmore="loadmore"
      :loading="controlItem.props.loading"
      @blur="handleBlur"
      :v-direction="controlItem.props.direction"
      :id="controlItem.prop"
      @change="handleChange"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <!-- 下拉框无限滚动 ID IDName -->
    <el-select
      v-else-if="
        controlItem.type === 'SelectInfiniteIDName' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      filterable
      remote
      :disabled="controlItem.props.disabled"
      :remote-method="remoteMethod"
      :placeholder="
        controlItem.props.placeholder !== ''
          ? '请选择' + controlItem.props.placeholder
          : '请选择' + controlItem.label
      "
      :style="controlItem.props.style"
      v-el-select-loadmore="loadmore"
      :loading="controlItem.props.loading"
      @blur="val => handleBlurCustomer(val)"
      :v-direction="controlItem.props.direction"
      :id="controlItem.prop"
      @change="handleChangeIDName($event, controlItem.value)"
      @visible-change="visibleChange"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <el-select
      v-else-if="
        controlItem.type === 'SelectInfiniteCustomer' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      filterable
      remote
      :disabled="controlItem.props.disabled"
      :remote-method="remoteMethod"
      :placeholder="controlItem.props.label"
      :style="controlItem.props.style"
      v-el-select-loadmore="loadmore"
      :loading="controlItem.props.loading"
      @blur="handleBlur"
      :v-direction="controlItem.props.direction"
      @change="handleChangeIDName($event, controlItem.value)"
      @visible-change="visibleChange"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="String(item.prop) + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <!-- 下拉框(可删除下拉选项) -->
    <el-select
      v-model="form[controlItem.prop]"
      :placeholder="'请输入或选择' + controlItem.label"
      v-else-if="controlItem.type === 'selectWithDel' && !controlItem.isDynamic"
      allow-create
      filterable
      @change="selectWithDelChange(controlItem.prop)"
      :style="controlItem.props.style"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="item.prop + String(Math.random())"
        :label="item.label"
        :value="item.prop"
      >
        <template>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div>{{ item.prop }}</div>
            <i
              class="el-icon-delete"
              @click="deloptions(item.prop, controlItem.prop)"
            ></i>
          </div>
        </template>
      </el-option>
    </el-select>
    <!-- 级联选择器 -->
    <el-cascader
      v-else-if="controlItem.type === 'Cascader' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :options="controlItem.value"
      :id="controlItem.props.id"
      :props="controlItem.props"
      :style="controlItem.props.style"
      :collapse-tags="controlItem.props.collapseTags"
      :clearable="controlItem.props.clearable"
      @change="CascaderChange"
      :v-direction="controlItem.props.direction"
      :ref="controlItem.prop"
      :disabled="controlItem.props.disabled"
    ></el-cascader>
    <!-- 单选 选择器 -->
    <el-cascader
      v-else-if="
        controlItem.type === 'CasCaderChoice' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      :options="controlItem.value"
      :props="controlItem.props.checkStrictly"
      :style="controlItem.props.style"
      :clearable="controlItem.props.clearable"
      @change="CascaderChange"
      :ref="controlItem.prop"
    ></el-cascader>
    <!-- 下拉框多次搜索 多选 -->
    <el-select
      v-else-if="
        controlItem.type === 'SelectInfinitemultiple' && !controlItem.isDynamic
      "
      v-model="form[controlItem.prop]"
      filterable
      multiple
      :reserve-keyword="true"
      collapse-tags
      :placeholder="'请选择' + controlItem.label"
      :style="controlItem.props.style"
      :loading="controlItem.props.loading"
      :id="controlItem.prop"
      :disabled="controlItem.props.disabled"
      @change="SelectInfinitemultipleChange"
    >
      <el-option
        v-for="item in controlItem.value"
        :key="item.prop"
        :label="item.label"
        :value="item.prop"
      ></el-option>
    </el-select>
    <!-- 计数器 -->
    <el-input-number
      v-else-if="controlItem.type === 'InputNumber' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      controls-position="right"
      :min="0"
      :v-direction="controlItem.props.direction"
      :controls="controlItem.props.controls"
      :style="controlItem.props.style"
    ></el-input-number>
    <!-- 时间选择器 (带时刻)-->
    <el-date-picker
      v-else-if="controlItem.type === 'datetime' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      type="datetime"
      :placeholder="'请选择' + controlItem.label"
      :picker-options="pickerOptions"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
    >
    </el-date-picker>
    <!-- 时间选择器  没有范围控制 -->
    <el-date-picker
      v-else-if="controlItem.type === 'DateNone' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      type="date"
      :placeholder="'请选择' + controlItem.label"
      value-format="yyyy-MM-dd"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
    >
    </el-date-picker>
    <!-- 时间选择器 -->
    <el-date-picker
      v-else-if="controlItem.type === 'Date' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      type="date"
      :placeholder="'请选择' + controlItem.label"
      :picker-options="pickerOptions"
      value-format="yyyy-MM-dd"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
    >
    </el-date-picker>
    <!-- 时间范围选择（天） -->
    <el-date-picker
      v-else-if="controlItem.type === 'Daterange' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      type="daterange"
      align="center"
      :editable="false"
      unlink-panels
      range-separator="-"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      show-week-number="true"
      size="large"
      class="date-class"
      :format="format"
      :picker-options="pickerOptionsType"
      value-format="yyyy-MM-dd"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
      @blur="OmitDate"
      :clearable="controlItem.props.clearable"
    >
    </el-date-picker>
    <!-- 时间范围选择（月） -->
    <el-date-picker
      v-else-if="controlItem.type === 'Monthrange' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :editable="false"
      type="monthrange"
      align="center"
      unlink-panels
      range-separator="-"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      size="large"
      class="date-class"
      value-format="yyyy-MM"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
      :clearable="controlItem.props.clearable"
    >
    </el-date-picker>
    <!-- 时间范围选择（12月） -->
    <el-date-picker
      v-else-if="controlItem.type === 'Monthrange12' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :editable="false"
      type="monthrange"
      align="center"
      unlink-panels
      range-separator="-"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      size="large"
      class="date-class"
      :picker-options="pickerOptions12Month"
      value-format="yyyy-MM"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
      @blur="resetMinDate"
      :clearable="controlItem.props.clearable"
    >
    </el-date-picker>
    <!-- 选择月 -->
    <el-date-picker
      v-else-if="controlItem.type === 'Month' && !controlItem.isDynamic"
      v-model="form[controlItem.prop]"
      :editable="false"
      type="month"
      align="center"
      unlink-panels
      range-separator="-"
      size="large"
      class="date-class"
      value-format="yyyy-MM"
      :v-direction="controlItem.props.direction"
      :style="controlItem.props.style"
    >
    </el-date-picker>
    <!-- 时间范围选择(年) 清空表单时需要单独清空
    清空方法：
    // 加定时器，防止$emit先于$on执行了，否则无法获得第一次数据；
            setTimeout(() => {
                this.$bus.emit('clearYear')
            });
    -->
    <YearRange
      v-model="form[controlItem.prop]"
      v-else-if="controlItem.type === 'Yearrange' && !controlItem.isDynamic"
      class="date-class"
      :style="controlItem.props.style"
      @yearSelect="yearSelect"
    />
    <!-- 时间范选择 拆分框 -->
    <TimeInterval
      v-model="form[controlItem.prop]"
      v-else-if="controlItem.type === 'TimeInterval' && !controlItem.isDynamic"
      :timerStyle="controlItem.props.style"
      @changeTime="changeTime"
    />
    <!-- 数值范围控件 -->
    <!-- 需要在props内传入最大值和最小值分别对应的model
    minValue："最小值model"
    maxValue："最大值model"
    可以不写prop，但清空表单时需要单独清空
    -->
    <div
      v-else-if="controlItem.type === 'Digitalrange' && !controlItem.isDynamic"
      :style="controlItem.props.style"
    >
      <el-input
        :disabled="form[controlItem.props.disabled]"
        @input="
          form[controlItem.props.minValue] = form[
            controlItem.props.minValue
          ].match(/\d*\.{0,1}\d{0,4}/)[0]
        "
        v-model="form[controlItem.props.minValue]"
        class="Digitalrange"
        @blur="
          checkInput(controlItem.props.minValue, controlItem.props.maxValue)
        "
      ></el-input>
      <span style="margin: 0 15px">~</span>
      <el-input
        :disabled="form[controlItem.props.disabled]"
        @input="
          form[controlItem.props.maxValue] = form[
            controlItem.props.maxValue
          ].match(/\d*\.{0,1}\d{0,4}/)[0]
        "
        v-model="form[controlItem.props.maxValue]"
        class="Digitalrange"
        @blur="
          checkInput(controlItem.props.minValue, controlItem.props.maxValue)
        "
      ></el-input>
    </div>
  </el-form-item>
</template>

<script>
import * as common from "@/assets/js/common";
// 年选择器组件
import YearRange from "./yearrange";
import TimeInterval from "./TimeInterval.vue";
import { console } from "node-libs-browser";
export default {
  components: { YearRange, TimeInterval },
  props: {
    controlItem: {
      // 选择类型
      type: "",
      // 绑定表单
      model: "",
      // 控件名称
      label: "",
      // 控件属性名
      prop: "",
      // 控件子节点值
      value: [],
      // 是否可以动态增减
      isDynamic: true,
      /* 全选 */
      checked: true,
      // 控件配置
      props: {}
    },
    // 表单中所绑定的值
    dynamicItem: {},
    form: {}
  },
  // watch: {
  //   // 数值范围绑定值
  //   minValue:function (newVal,OldVal) {
  //     if (newVal!==OldVal) {
  //       this.$emit("")
  //     }
  //   }
  // },

  data() {
    let that = this;
    return {
      newDate: [],
      duration: [],
      pickerOptions: {
        firstDayOfWeek: 1,
        // 时间选择器只能选择今天及今天之前
        disabledDate(time) {
          let currentDate = that.duration[0];
          var threeDate = new Date();
          let threeMounth = 60 * 60 * 1000 * 90 * 24;

          threeDate.setMonth(threeDate.getMonth() - 3);
          if (currentDate) {
            // console.log(currentDate.getMonth());
            // currentDate.setMonth(currentDate.getMonth() + 2);
            // console.log(currentDate.getTime(), threeDate.getTime());
            if (currentDate.getTime() - threeDate.getTime() < 0) {
              return (
                time.getTime() < currentDate.getTime() - threeMounth ||
                time.getTime() > currentDate.getTime() + threeMounth
              );
            } else {
              return (
                time.getTime() < currentDate.getTime() - threeMounth ||
                time.getTime() > new Date().getTime()
              );
            }
          }
          // return time.getTime() > Date.now(); //选择当前时间之前的也写一下
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
        onPick({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            that.duration[0] = minDate;
          } else if (!minDate && maxDate) {
            that.duration[0] = maxDate;
          }
        }
      },

      // 数值范围输入框绑定值
      minValue: null,
      maxValue: null,
      passwordType: "password",
      firstDateMoment: "",

      dateList: [],
      minDate: null,
      maxDate: null,
      pickerOptions12Month: {
        disabledDate: time => {
          if (this.minDate !== null && this.maxDate === null) {
            let minMonth = this.minDate.getMonth(),
              lastYear = new Date(this.minDate).setMonth(minMonth - 11),
              nextYear = new Date(this.minDate).setMonth(minMonth + 11);
            // 只能选 minDate 前后一年的范围
            return (
              time.valueOf() < lastYear.valueOf() ||
              time.valueOf() > nextYear.valueOf()
            );
          }
          return false;
        },
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        }
      }
    };
  },
  computed: {
    date: {
      get() {
        let newDate = this.newDate;
        if (newDate && newDate.length <= 0) {
          let endDate = common.addDays(new Date(), -1);
          let beginDate = endDate;
          newDate = [beginDate, endDate];
        }
        return newDate;
      },
      set(newDate) {
        if (newDate && newDate.length > 0) {
          let weekStart = common.getWeekStartAndEnd(0, new Date(newDate[0]));
          let weekEnd = common.getWeekStartAndEnd(0, new Date(newDate[1]));
          this.newDate = [weekStart[0], weekEnd[1]];
        }
      }
    },
    format: {
      get() {
        let timeType = this.time;
        let date = this.date;
        if ("week" == timeType && date && date.length > 0) {
          let beginYearWeek = common.getYearAndWeek(date[0], date[1]);
          let endYearWeek = common.getYearAndWeek(date[1], date[0]);
          return beginYearWeek + endYearWeek;
        } else {
          return "";
        }
      }
    },

    dateType: {
      get() {
        return this.dateType;
      }
    },

    pickerOptionsType: {
      get() {
        return this.pickerOptions;
      }
    }
  },
  methods: {
    visibleChange(val) {
      this.$emit("visibleChange", val);
    },
    changeRadio(val) {
      this.$emit("changeRadio", val);
    },
    SelectInfinitemultipleChange() {
      this.$emit("SelectInfinitemultipleChange");
    },
    resetMinDate() {
      if (
        this.dateList &&
        this.dateList.length &&
        this.minDate &&
        !this.maxDate
      ) {
        this.minDate = new Date(this.dateList[0]);
      } else {
        this.minDate = null;
      }
    },
    selectWithDelChange(val) {
      this.$emit("selectWithDelChange", val);
    },
    deloptions(val, prop) {
      this.$emit("deloptions", { val, prop });
    },
    /* 全选 */
    selectAll() {
      this.$emit("selectAll");
    },
    OmitDate() {
      this.duration = ["", ""];
    },
    // willChangeDate(value) {
    //   // this.firstDateMoment = time[0];
    //   console.log(value);
    // },
    autocompleteSelect(val) {
      this.$emit("autocompleteSelect", val);

      console.log(val);
    },
    selectID(ID) {},
    handleChangeIDName(val, arr) {
      this.$emit("SelectChangeIDName", val, arr);
    },
    handleChange(val) {
      this.$emit("getAgentID", val);
      this.$emit("SelectChange", val);
    },
    SelectChange(val) {
      this.$emit("getAgentID", val);
      this.$emit("SelectChange", val);
      // 多选可隐藏改变值
      this.$emit("SelectChangeHidden", val);
    },
    CascaderChange(val) {
      const that = this;
      this.$emit("CascaderChange", that);
      this.$emit("addressChange", val);
    },
    InputChange(val) {
      this.$emit("InputChange", val);
    },
    // 当queryString不为空的时候，就说明用户输入内容了，我们把用户输入的内容在数据库中做对比，如果有能够模糊关联的，就直接取出
    // 并返回给带搜索建议的输入框，输入框就把返回的数据以下拉框的形式呈现出来，供用户选择。
    querySearch(queryString, cb) {
      this.$emit("InputChange", queryString, cb);
    },
    // 点击谁，就把谁放进去
    handleSelect(item) {
      this.$emit("handleSelect", item);
    },
    // 聚焦
    handleFocus() {
      this.$emit("handleFocus");
    },
    // 下拉列表加载
    loadmore() {
      this.$emit("loadmore");
      this.$emit("loadmore1");
    },
    // 模糊匹配远程搜索
    remoteMethod(query) {
      this.$emit("remoteMethod", query);
      this.$emit("remoteMethod1", query);
    },
    // 下拉框失去焦点
    handleBlur() {
      this.$emit("handleBlur");
      this.$emit("handleBlur1");
    },
    handleBlurCustomer() {
      this.$emit("handleBlurCustomer");
    },
    // 年选择器
    yearSelect(val) {
      this.controlItem.value = val;
      this.$emit("yearSelect", val);
    },
    // 时间选择器拆分
    changeTime(val) {
      this.controlItem.value = val;
      this.$emit("changeTime", val);
    },
    resetForm(val) {
      console.log("in");
    },
    // 下拉框改变
    selectChangehandel(val) {
      this.$emit("selectChangehandel", val);
    },
    isFloat(num) {
      var y = String(num).indexOf(".") + 1; //获取小数点的位置
      if (y > 0) {
        return true;
      } else {
        return false;
      }
    },
    // 失焦时检查输入是否正确
    checkInput(min, max) {
      if (this.form[min] && this.form[max]) {
        var minLength = this.form[min].indexOf(".") + 1; //获取小数点的位置
        var maxLength = this.form[max].indexOf(".") + 1; //获取小数点的位置
        if (minLength > 0 || maxLength > 0) {
          if (parseInt(~~this.form[min]) > parseInt(~~this.form[max])) {
            let tmp = this.form[min];
            this.form[min] = this.form[max];
            this.form[max] = tmp;
            return;
          } else if (
            parseInt(~~this.form[min]) === parseInt(~~this.form[max])
          ) {
            if (parseFloat(this.form[min]) > parseFloat(this.form[max])) {
              let tmp = this.form[min];
              this.form[min] = this.form[max];
              this.form[max] = tmp;
              return;
            }
          }
        } else {
          if (this.form[min] && this.form[max]) {
            if (~~this.form[min] > ~~this.form[max]) {
              let tmp = this.form[min];
              this.form[min] = this.form[max];
              this.form[max] = tmp;
            }
          }
        }
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    }
  },
  created() {},
  mounted() {
    this.restaurants = this.controlItem.value;
  }
};
</script>

<style>
.hiddenOption {
  visibility: hidden;
}
.el-form-item {
  margin-bottom: 16px;
}

.el-form--inline .el-form-item__label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #313131;
}

.el-form--inline[data-v-4c987925] .el-form-item {
  margin-left: 11px;
}

.Digitalrange {
  width: 80px !important;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  fill: gray;
}

.checkbox {
  margin-left: 210px;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/FormControl.vue